export const MENU_LINKS = [
  {
    id: 1,
    caption: 'Mi mesa',
    link: '/my-table',
  },
  {
    id: 2,
    caption: 'Agregar regalos',
    link: '/agregar-regalos',
  },
  {
    id: 3,
    caption: 'Regalos recibidos',
    link: '/regalos-recibidos',
  },
  {
    id: 4,
    caption: 'Compartir mi mesa',
    link: '/compartir-mesa',
  },
  /*{
    id: 8,
    caption: 'Perfil',
    link: '#',
  },*/
  /*
  {
    id: 9,
    caption: 'Mis invitados',
    link: '/rsvp',
  },
  */
  {
    id: 7,
    caption: 'Buscar evento',
    link: '/buscar-evento',
  },

];
